import { put, takeEvery} from "redux-saga/effects";

import { ToastContainer, toast,Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  LOGIN_INIT_ACTION,
  FETCH_LOGIN_FAIL_ACTION,
  FETCH_LOGIN_SUCCESS_ACTION,
  LOGOUT_ACTION,
  LSENDOTP_SUCCESS_ACTION,
  LSENDOTP_FAIL_ACTION
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* login(cred) {
  // console.log("ip==", appConfig.ip)
  try {
    const loginData = {
      UserID: cred.cred.UserID,
      password: cred.cred.password,
    };

    const roleRes = yield fetch(
      `${appConfig.ip}/users/role/${encodeURIComponent(loginData.UserID)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );

    if (!roleRes.ok) {
      throw roleRes;
    }

    const roleJSON = yield roleRes.json();
    const body = {
      role: roleJSON.role,
    };

    const res = yield fetch(`${appConfig.ip}/auth/byRole`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(loginData.UserID + ":" + loginData.password),
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      const userDetails = resJSON.user;
      const distributorID =
        userDetails.role === "employee" ? userDetails.distributor : userDetails.id;
      yield put({
        type: FETCH_LOGIN_SUCCESS_ACTION,
        payload: resJSON,
      });
      localStorage.setItem("distributorId", distributorID);
      localStorage.setItem("UserRole", userDetails.role);
      localStorage.setItem("token", resJSON.token);
      localStorage.setItem("userDetails", JSON.stringify(userDetails));

      if (resJSON.user.phnCnfrmd === false) {
        try {
          const token = localStorage.getItem("token");
          const data = {};
          const res2 = yield fetch(`${appConfig.ip}/phoneVerify/sendotp`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
          });
      
          if (!res2.ok) {
            throw res2;
          } else {
            const res2JSON = yield res2.json();
            yield put({
              type: LSENDOTP_SUCCESS_ACTION,
              payload: res2JSON,
            });
            /* yield toast.success("OTP Sent", {
              autoClose: 3000,
            }); */
            yield put(push("/verifyotp"));
          }
        } catch (err) {
      
          yield put({
            type: LSENDOTP_FAIL_ACTION,
            payload: err,
          });
        }
      } else if (resJSON.user.phnCnfrmd === true && resJSON.user.ftLogin === true && resJSON.user.status === "active") {
        yield put(push("/updateprofile"));
      } else if (resJSON.user.phnCnfrmd === true && resJSON.user.ftLogin === false && resJSON.user.status === "active") {
        yield put(push("/dashboard"));
      } else if (resJSON.user.status === "suspended"){
        yield put(push("/suspendprompt"));
      }
      yield toast.success("Login successful", {
        autoClose: 3000,
        transition:Flip
      });
    }
  } catch (err) {
      if(err.status=== 401) {
        yield toast.error("You may have entered invalid credentials or have failed to register", {
          autoClose: 3000,
          //position: "top-center",
          transition:Flip
        });
      } else if(err.status === 406){
        yield toast.error("User not registered as a distributor", {
          autoClose: 3000,
          //position: "top-center",
          transition:Flip
        });
      }else {
        yield toast.error("You may have entered invalid credentials or have failed to register", {
          autoClose: 3000,
          transition:Flip
        });
      }
      yield put({
        type: FETCH_LOGIN_FAIL_ACTION,
        payload: err,
      }); 

  }
}

function* logOut() {
  localStorage.removeItem("token");
}
export function* LoginActionWatcher() {
  yield takeEvery(LOGIN_INIT_ACTION, login);
  yield takeEvery(LOGOUT_ACTION, logOut);
}
